import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("mt_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem("mt_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("mt_user", JSON.stringify(data));
    } catch {
      localStorage.removeItem("mt_token");
      localStorage.removeItem("mt_user");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
  }, [refreshMe]);

  const signin = async (email, password) => {
    const { data } = await api.post("/auth/signin", { email, password });
    localStorage.setItem("mt_token", data.token);
    localStorage.setItem("mt_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/signup", payload);
    localStorage.setItem("mt_token", data.token);
    localStorage.setItem("mt_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const signout = () => {
    localStorage.removeItem("mt_token");
    localStorage.removeItem("mt_user");
    setUser(null);
  };

  const updateUser = (u) => {
    setUser(u);
    localStorage.setItem("mt_user", JSON.stringify(u));
  };

  return (
    <AuthContext.Provider value={{ user, loading, signin, signup, signout, refreshMe, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
